import React from "react";

const ExclusivePartnership = () => (
  <>
    {/* Hero Section */}
    <section
      className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(90deg, rgba(252, 53, 236, 1) 0%, rgba(237, 0, 170, 1) 100%)",
      }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        }}
      ></div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik] leading-tight">
          Exclusive Partnership Opportunities
        </h1>
      </div>
    </section>

    {/* Content Section */}
    <div className="max-w-5xl mx-auto py-16 px-6 text-gray-800">
      <h2 className="text-3xl font-extrabold mb-6 text-main-pink">
        Own the Spotlight. Lead the Change.
      </h2>

      <p className="text-base leading-relaxed mb-4">
        <strong>Pink Help</strong> offers exclusive partnership rights to organizations, institutions, and individuals who want to lead, represent,
        and monetize their category or country within the world’s first women-focused global platform.
      </p>

      <p className="text-base leading-relaxed mb-4">
        With over 250 dedicated country portals and 10 core service categories, we are opening doors for a select few to hold category-wide exclusivity —
        becoming the sole visible partner in a specific field within a specific region.
      </p>

      <p className="text-base leading-relaxed mb-4">
        Whether you are a legal firm in the UAE, a health clinic in Canada, or a fintech startup in Nigeria, your exclusive listing ensures that your brand stands alone
        in your selected category — gaining maximum visibility, authority, and trust.
      </p>

      <h3 className="text-2xl font-semibold mt-10 mb-4 text-main-pink"> What You Get:</h3>
      <ul className="list-disc list-inside text-base text-gray-700 space-y-2 mb-6">
        <li>Your logo and listing at the top of every relevant page</li>
        <li>Homepage spotlight within your country portal</li>
        <li>A permanent “Premium Partner” badge on your listing</li>
        <li>Social media exposure as the category leader in your region</li>
        <li>Access to direct leads and inquiries through our help-seeker form system</li>
      </ul>

      <p className="text-base leading-relaxed mb-4">
        Our exclusive partners are more than advertisers — they are recognized allies in women's empowerment and pillars of credibility in their industries.
      </p>

      <h3 className="text-2xl font-semibold mt-10 mb-4 text-main-pink"> Limited Availability:</h3>
      <p className="text-base leading-relaxed mb-6">
        Only 1 exclusive partner per category per country. Once taken, the category locks.
      </p>

      <p className="text-base leading-relaxed mb-6">
        This is your opportunity to own the category that aligns with your mission, reach thousands of targeted users,
        and grow your business while standing for something greater.
      </p>

      <div className="mt-8">
        <a
          href="/apply-for-exclusivity"
          className="inline-block bg-main-pink hover:bg-pink-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200"
        >
          Apply for Exclusivity
        </a>
      </div>
    </div>
  </>
);

export default ExclusivePartnership;
